import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Controller } from "react-hook-form";

import type { CustomFieldComponentProps } from "../types";

const RadioComponent = ({
  field,
  methods,
}: CustomFieldComponentProps<"radio">): React.JSX.Element => {
  const {
    formState: { errors },
  } = methods;
  const error = errors[field.name];

  return (
    <FormControl
      component="fieldset"
      error={Boolean(error)}
      disabled={field.disabled}
      required={field.required}
    >
      {field.label ? (
        <FormLabel component="legend">{field.label}</FormLabel>
      ) : null}
      <Controller
        name={field.name}
        control={methods.control}
        defaultValue={field.defaultValue || ""}
        render={({ field: { onChange, ...controllerField } }) => (
          <RadioGroup
            {...controllerField}
            onChange={(e, value) => {
              field.onChange?.(e, value);
              onChange(e, value);
            }}
            row={field.row ?? true}
          >
            {field.options?.map((option) => (
              <FormControlLabel
                key={String(option.value)}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        )}
      />
      {error && <FormHelperText>{error.message as string}</FormHelperText>}
    </FormControl>
  );
};

export default RadioComponent;
